#import "../fragments/landing-page-stub-fragment.graphql"

mutation DuplicateLandingPage($input: PageDuplicateInput!) {
    pageDuplicate(input: $input) {
        page {
            ...LandingPageStubFragment
        }
    }
}
